import config from '../../config/config';
// import { mockPrevetDataApprovalConditional } from './mockPrevetData';

export const PREVET_LOAD = 'PREVET/PREVET_LOAD';
export const PREVET_SUCCESS = 'PREVET/PREVET_SUCCESS';
export const PREVET_FAILURE = 'PREVET/PREVET_FAILURE';

export const PREVET_UPDATE_LOAD = 'PREVET/PREVET_UPDATE_LOAD';
export const PREVET_UPDATE_SUCCESS = 'PREVET/PREVET_UPDATE_SUCCESS';
export const PREVET_UPDATE_FAILURE = 'PREVET/PREVET_UPDATE_FAILURE';

export function getPrevetSuccessActionCreator(prevet) {
    return {
        prevet,
        type: PREVET_SUCCESS
    };
}

export function getPrevetFailureActionCreator(error) {
    return {
        error,
        type: PREVET_FAILURE
    };
}

export function getPrevet(prevetId) {
    //mock data for testing
    // if (prevetId === '123' || prevetId === 123) {
    //     //returns a mock action that immediately returns the mock data
    //     return {
    //         type: PREVET_SUCCESS,
    //         prevet: mockPrevetDataApprovalConditional
    //     };
    // }

    const url = `${config.underwritingApiUrl}/prevet/${prevetId}`;

    return {
        failureActionTypeOrCreator: getPrevetFailureActionCreator,
        fetchParams: {
            url
        },
        loadActionTypeOrCreator: PREVET_LOAD,
        successActionTypeOrCreator: getPrevetSuccessActionCreator
    };
}

export function updatePrevetSuccessActionCreator(prevet) {
    return {
        prevet,
        type: PREVET_UPDATE_SUCCESS
    };
}

export function updatePrevetFailureActionCreator(error) {
    return {
        error,
        type: PREVET_UPDATE_FAILURE
    };
}

export function updatePrevet(prevetId, data) {
    return {
        failureActionTypeOrCreator: updatePrevetFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/prevet/${prevetId}`,
            method: 'PUT',
            body: data
        },
        loadActionTypeOrCreator: PREVET_UPDATE_LOAD,
        successActionTypeOrCreator: updatePrevetSuccessActionCreator
    };
}